import React from "react";

const colors = [
  ["bg-red-100", "text-red-500"],
  ["bg-orange-100", "text-orange-500"],
  ["bg-yellow-100", "text-yellow-500"],
  ["bg-green-100", "text-green-500"],
  ["bg-teal-100", "text-teal-500"],
  ["bg-blue-100", "text-blue-500"],
  ["bg-indigo-100", "text-indigo-500"],
  ["bg-purple-100", "text-purple-500"],
  ["bg-pink-100", "text-pink-500"],
];
const Badge = ({ value }: { value: string }) => {
  const [color, setColor] = React.useState(colors[1]);
  React.useEffect(() => {
    setColor(colors[Math.floor(Math.random() * 10)]);
  }, []);

  return (
    <span
      className={`whitespace-nowrap inline-flex items-center rounded-full ${
        color ? color[0] + " " + color[1] : "bg-red-100 text-red-500"
      } px-2.5 py-0.5 text-xs font-medium`}
    >
      {value}
    </span>
  );
};

export default Badge;
